import { NgModule } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';


import { SharedModule } from '../../shared/shared.module';
import { PrivacyBannerComponent } from './privacy.component';
import { ButtonModule } from 'atlas-button';

export const COMPONENTS = [
  PrivacyBannerComponent
];

@NgModule({
  declarations: COMPONENTS,
  imports: [
    CommonModule,
    // // MercerOSModule,
    SharedModule,
    FormsModule,
    ButtonModule
  ],
  exports: COMPONENTS,
  providers: [],
  bootstrap: [],
  // entryComponents: COMPONENTS
})
export class PrivacyModule {
}
